import styled, {keyframes} from "styled-components";
import {DefaultTextBold, DefaultTextLight} from "components/text/Text";
import {CarouselIndexes} from "components/carousel/Carousel";

interface PlanCardContainerProps {
  index?: number,
  indexes?: CarouselIndexes
}

export const PlanCardContainer = styled.div<PlanCardContainerProps>`
  display: flex;
  flex-direction: column;
  height: calc(100% - 20px);
  flex: 1;
  border-radius: 20px;
  background-color: white;
  position: relative;
  padding-top: 20px;
  overflow: hidden;
  // if the index is either a prev or next index of the carousel, then ensure it has a pointer style
  cursor: ${props => (props.indexes &&
  (props.index === props.indexes.previousIndex || props.index === props.indexes.nextIndex) ? 'pointer' : 'default')};
`

export const PlanCardTopContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 55%;
`

export const PlanCardDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(70% - 10px);
  word-wrap: break-word;
  padding-left: 10px;
`

export const PlanCardName = styled(DefaultTextBold)`
  color: #2E3A59;
  font-size: 30px;

  @media (max-width: 1300px) {
    font-size: 25px;
  }

  @media (max-width: 700px) {
    font-size: 15px;
  }
`

export const PlanCardPrice = styled(DefaultTextLight)`
  font-size: 22px;
  color: #2E3A59;

  @media (max-width: 1300px) {
    font-size: 16px;
  }

  @media (max-width: 700px) {
    font-size: 10px;
  }
`

export const PlanCardRecommendation = styled(DefaultTextLight)`
  margin-top: 30px;
  font-size: 15px;
  color: #666;

  @media (max-width: 1300px) {
    font-size: 12px;
  }

  @media (max-width: 700px) {
    margin-top: 15px;
    font-size: 8px;
  }
`

export const PlanCardRecommendationSize = styled(DefaultTextLight)`
  margin-top: 20px;
  display: flex;
  font-size: 12px;
  color: #666;
  font-style: italic;

  @media (max-width: 1300px) {
    font-size: 10px;
  }

  @media (max-width: 700px) {
    margin-top: 15px;
    font-size: 6px;
  }
`

export const PlanCardImg = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  object-fit: contain;
  max-height: 20vh;
  max-width: 30%;
`

export const PlanCardBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: 1;
  background-color: #FEBFC5;
`

export const PlanCardFeatureSize = styled(DefaultTextBold)`
  color: #2E3A59;
  font-size: 40px;

  @media (max-width: 700px) {
    font-size: 20px;
  }
`

export const PlanCardFeatureDescription = styled(DefaultTextLight)`
  color: #2E3A59;
  font-size: 25px;
  margin-bottom: 10px;

  @media (max-width: 700px) {
    font-size: 15px;
  }
`

interface PlanCardActivePlanProps {
  isActive: boolean
}

export const PlanCardActivePlan = styled.div<PlanCardActivePlanProps>`
  display: flex;
  transition: all 1s linear;
  justify-content: center;
  align-items: center;
  border: 2px white solid;
  background-color: #FE2F67;
  width: 50%;
  border-radius: 10px;
  cursor: pointer;
  height: ${props => props.isActive ? '4vh' : 0};
  opacity: ${props => props.isActive ? 1 : 0};
  user-select: none;

  @media (max-width: 700px) {
    border-radius: 4px;
    border: 1px white solid;
    height: ${props => props.isActive ? '2vh' : 0};
  }
`

export const PlanCardActivePlanText = styled.p`
  color: white;
  font-size: 18px;

  @media (max-width: 700px) {
    font-size: 10px;
  }
`
